import { ReactElement } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import crossSectionAxesImage from 'src/assets/img/cross-section-axes.svg'

/**
 * Plan view of the cross section of a rip or column with its local y and z axes
 * and a load point with positive e_y and e_z, so the sign of the eccentricity is
 * clear: a positive e_y / e_z moves the load towards +y / +z.
 */
const CrossSectionAxesSketch = (): ReactElement => (
  <Stack direction="row" spacing={2} alignItems="center" data-cy="load-eccentricity-sketch">
    <Box
      component="img"
      src={crossSectionAxesImage}
      alt="Querschnitt mit y- und z-Achse und einem Lastangriffspunkt mit positiven Exzentrizitäten in y- und z-Richtung"
      sx={{ width: 180, flexShrink: 0 }}
    />
    <Stack spacing={0.5}>
      <Typography variant="caption" color="text.secondary">
        Draufsicht auf den Querschnitt. Positive Werte versetzen die Last in Richtung der positiven
        Achse.
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Rippe: +y in Wandrichtung (vom Wandanfang zum Wandende), +z senkrecht zur Wand, in
        Wandrichtung gesehen nach links.
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Stütze: +y in globaler Y-Richtung, +z entgegen der globalen X-Richtung.
      </Typography>
    </Stack>
  </Stack>
)

export default CrossSectionAxesSketch
